<template>
  <popup-block
    :closeModal="closeModal"
    :green_header="!info_icon"
    :green_header_info="info_icon"
    :shown="opened">
    <div
      class="default-title"
      v-html="title"
    />
    <div class="mt-20" v-html="body"/>
  </popup-block>
</template>

<script>
import PopupBlock from "../modules/PopupBlock";
import DefaultTitle from "../small_parts/DefaultTitle.vue";

export default {
  name: 'FormSubmittingPopup',
  components: {
    DefaultTitle,
    PopupBlock
  },
  props: {
    title: {
      type: String,
      default: 'Thanks!',
      required: true
    },
    body: {
      type: String,
      default: 'Thank you for filling out the form!',
      required: true
    },
    info_icon: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      opened: false,
    }
  },
  methods: {
    openModal() {
      this.opened = true
      //setTimeout(this.closeModal, 5000)
    },
    closeModal() {
      this.opened = false
      this.$emit('closed', true)
    },
  },
}
</script>
